<template>
    <div class="tip" v-if="tipShow">
        <div class="tipContent">
            <div class="topTitle">{{title}}</div>
            <div class="tipText">{{text}}</div>
            <div class="tipOperation" v-if="btnArr.length > 0">
                <button v-for="(item,index) in btnArr" :key="index" 
                    :style="item.style || ''" 
                    @click="callback(item.text || item, index, item.id)" 
                    v-pressed
                >{{item.text || item}}</button>
            </div>
            <div class="close" v-if="closeShow" @click="close()"></div>
        </div>
    </div>
</template>
<script>
export default {
    name:"alertTip",
    data(){
        return {
            show:false
        }
    },
    props:{
        tipData:{
            type:Object,
            required:true
        },
        tipShow:Boolean,
    },
    computed:{
        title:function(){
            return this.tipData.title || "";
        },
        text:function(){
            return this.tipData.text || "";
        },
        btnArr:function(){
            var arr = [];
            if(this.tipData.btnArr.length>0){
                arr = this.tipData.btnArr.splice(0,2);
            }
            return arr;
        },
        closeShow:function(){
            if(typeof this.tipData.close == 'boolean'){
                return this.tipData.close;
            }else{
                return true;
            }
        }
    },
    methods:{
        callback(text,index,id){
            this.$emit("btnCallback",text,index,id);
        },
        close(){
            this.$emit("closeCallback");
        }
    }
}
</script>
<style lang="scss" scoped>
    .tip{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
        .tipContent{
            width: 630px;
            height: 306px;
            background: #FFFFFF;
            box-shadow: 0px 12px 40px -8px rgba(136,136,136,0.25);
            border-radius: 20px;
            padding-top: 48px;
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
            .topTitle{
                width: 100%;
                @include line-height(44px);
                font-size: 32px;
                color: #1B1C1E;
                text-align: center;
                font-weight: 500;
            }
            .tipText{
                width: 100%;
                min-height: 124px;
                padding: 24px 20px;
                box-sizing: border-box;
                font-size: 28px;
                color: #3A3F49;
                text-align: center;
                line-height: 44px;
                font-weight: 400;
            }
            .tipOperation{
                width: 100%;
                border-top: 1px solid #EFEFEF;
                display: flex;
                button{
                    flex: 1;
                    @include line-height(89px);
                    font-size: 28px;
                    color: #3A3F49;
                    text-align: center;
                    font-weight: 500;
                    border-right: 1px solid #EFEFEF;
                    box-sizing: border-box;
                    &.pressed{
                        background: rgba(0,0,0,0.05);
                    }
                    &:last-of-type{
                        color: #FFA61C;
                        border-right: none;
                    }
                }
            }
            .close{
                width: 48px;
                height: 48px;
                position: absolute;
                top: 16px;
                right: 16px;
                @include bg-image("../assets/images/icon/icon_dialog_close");
                background-size: 100% 100%;
            }
        }
    }
</style>